import { createAction, props } from '@ngrx/store';
import { Household } from '../../../shared/models/household.model';

export const loadHouseholds = createAction('[Household] Load Households');
export const loadHouseholdsSuccess = createAction('[Household] Load Households Success', props<{ households: Household[] }>());
export const loadHouseholdsFailure = createAction('[Household] Load Households Failure', props<{ error: any }>());

// Set active household
export const setActiveHousehold = createAction(
    '[Household] Set Active Household',
    props<{ household: Household }>()
  );
  
  // Clear household data
  export const clearHouseholds = createAction('[Household] Clear Household State');
